package space.stanton.pages.posts

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initBp_2024_08_11_why_i_love_kotlinPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("posts/bp_2024_08_11_why_i_love_kotlin.md", FrontMatterElement.Builder { addScalar("title", "Why I love Kotlin"); addScalar("type", "blogpost"); addScalar("date", "2025_05_17"); addScalar("hidden", "true"); }))
}

@Page("/posts/bp-2024-08-11-why-i-love-kotlin")
@Composable
fun Bp_2024_08_11_why_i_love_kotlinPage() {
    space.stanton.components.layouts.BlogPost {
        org.jetbrains.compose.web.dom.H1(attrs = { id("why-i-love-kotlin") }) {
            org.jetbrains.compose.web.dom.Text("Why I love kotlin")
        }
    }
}
